/* 
  Generic reducers live here, such as just setting error state or loading state
*/

import { PayloadAction } from '@reduxjs/toolkit';

interface ReducerState<ReducerType> {
  loading: boolean;
  error?: string;
  data?: ReducerType;
}

export const handleRejected = <StateData, ErrorPayload>(
  state: ReducerState<StateData>,
  action: PayloadAction<ErrorPayload>,
) => {
  state.loading = false;
  state.error =
    typeof action.payload === 'string' ? action.payload : JSON.stringify(action.payload);
};

export const handlePending = <StateData>(state: ReducerState<StateData>) => {
  state.error = undefined;
};
